import { render, staticRenderFns } from "./WorkflowView.vue?vue&type=template&id=7032f5e8&scoped=true"
import script from "./WorkflowView.vue?vue&type=script&lang=ts"
export * from "./WorkflowView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032f5e8",
  null
  
)

export default component.exports